import { TimeRecordDataService } from '@/Widgets/LogTimeDrawerWidget/services/timeRecordDataService'

interface Params {
  isOpen: boolean
  customer: string | null
  order: string | null
  leaderId: string | null
  currentUserId: string
}

const toOption = ({ id, name }: { id: string; name: string }) => ({
  label: name,
  value: id,
})

export const useCascadingOptions = ({
  isOpen,
  customer,
  order,
  leaderId,
  currentUserId,
}: Params) => {
  const customerOptions = isOpen
    ? TimeRecordDataService.getClientsForUser(leaderId || currentUserId).map(
        toOption,
      )
    : []

  const orderOptions = customer
    ? TimeRecordDataService.getOrders(customer).map(toOption)
    : []

  const workPackageOptions =
    customer && order
      ? TimeRecordDataService.getPositions(order).map(toOption)
      : []

  return { customerOptions, orderOptions, workPackageOptions }
}
